module.exports = __webpack_public_path__ + "media/images/admin/icons/smartphone-b0ad795e4aca8f85be7aa231af547de9.svg";